/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default () =>
{
  return document.documentElement.clientWidth < 600 || document.documentElement.clientHeight < 550;
}
